import { render, staticRenderFns } from "./ModalQuiz.vue?vue&type=template&id=892b623e&"
import script from "./ModalQuiz.vue?vue&type=script&lang=js&"
export * from "./ModalQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports